import {
  CandleErrorCallback,
  CandleInterval,
  CandleUpdateCallback,
  ExchangeCandleWsAdapter,
} from "../../candle.types";

/** Live WS is unavailable in the browser for CORS-blocked exchanges. */
export const noopCandlesWsAdapter: ExchangeCandleWsAdapter = {
  subscribe(
    _symbol: string,
    _interval: CandleInterval,
    _onUpdate: CandleUpdateCallback,
    _onError?: CandleErrorCallback
  ): () => void {
    return () => {};
  },
};
